import * as React from "react";
import { SVGProps, memo } from "react";
const SvgTableIcon14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 5v1.75h3V5h1v1.75H12v1H9.5v1.5H12v1H9.5V12h-1v-1.75h-3V12h-1v-1.75H2v-1h2.5v-1.5H2v-1h2.5V5h1Zm3 2.75h-3v1.5h3v-1.5Z"
      fill="#666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10ZM2 5v7h10V5H2Zm0-1h10V2H2v2Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgTableIcon14Px);
export default Memo;
